import React from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { IdentificationFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';

interface DocumentsStepProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const DocumentsStep: React.FC<DocumentsStepProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="p-4 sm:p-6">
            <IdentificationFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />
        </div>
    );
};

export default DocumentsStep;
